module.exports = __webpack_public_path__ + "static/img-21b67fa922d00474302bcbe990e9e43a.png";